// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import axios from 'axios';
import VueAxios from 'vue-axios';
import locale from 'element-ui/lib/locale/lang/en';
import '../theme/element-variables.scss';
import App from './App';
import router from './router';

Vue.config.productionTip = false;
Vue.use(ElementUI, {
  locale,
});


axios.defaults.baseURL = 'https://author.businessexpertpress.com/api';
//axios.defaults.baseURL = 'http://127.0.0.1:3002';
//axios.defaults.baseURL = 'http://192.168.122.160:3002';

axios.defaults.headers.common.Authorization = `Bearer ${localStorage.token}`;
axios.interceptors.response.use(null, (error) => {
  if (error.response.status === 401) {
    router.push('/login');
  }
  return Promise.reject(error);
});

Vue.use(VueAxios, axios);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App,
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js